import { Lang } from '../../Lang';
import { FormGroup2, FormRow2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2, Select2, Switch2 } from 'bambooo';
/**
 * UsersEditModal
 */
export class UsersEditModal extends ModalDialog2 {
    /**
     * constructor
     */
    constructor() {
        super({ modalType: ModalDialogType2.large });
        /**
         * id of entry
         * @protected
         */
        this._id = null;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const groupUsername = new FormGroup2({ label: new LangTextV2({ text: 'Username' }) });
        groupUsername.appendTo(bodyCard);
        this._inputUsername = new Input2({});
        this._inputUsername.appendTo(groupUsername);
        this._inputUsername.setPlaceholder(Lang.i().l('Name of user'));
        const groupFullname = new FormGroup2({ label: new LangTextV2({ text: 'Fullname' }) });
        groupFullname.appendTo(bodyCard);
        this._inputFullname = new Input2({});
        this._inputFullname.appendTo(groupFullname);
        this._inputFullname.setPlaceholder(Lang.i().l('Fullname of user'));
        const groupPassword = new FormGroup2({ label: new LangTextV2({ text: 'Password' }) });
        groupPassword.appendTo(bodyCard);
        this._inputPassword = new Input2({ type: InputType2.password });
        this._inputPassword.appendTo(groupPassword);
        this._inputPassword.setPlaceholder('');
        const groupPasswordRepeat = new FormGroup2({ label: new LangTextV2({ text: 'Password repeat' }) });
        groupPasswordRepeat.appendTo(bodyCard);
        this._inputPasswordRepeat = new Input2({ type: InputType2.password });
        this._inputPasswordRepeat.appendTo(groupPasswordRepeat);
        this._inputPasswordRepeat.setPlaceholder('');
        const groupPing = new FormGroup2({ label: new LangTextV2({ text: 'Pin' }) });
        groupPing.appendTo(bodyCard);
        this._inputPin = new Input2({ type: InputType2.password });
        this._inputPin.appendTo(groupPing);
        this._inputPin.setPlaceholder('');
        const groupPinRepeat = new FormGroup2({ label: new LangTextV2({ text: 'Pin repeat' }) });
        groupPinRepeat.appendTo(bodyCard);
        this._inputPinRepeat = new Input2({ type: InputType2.password });
        this._inputPinRepeat.appendTo(groupPinRepeat);
        this._inputPinRepeat.setPlaceholder('');
        const groupEMail = new FormGroup2({ label: new LangTextV2({ text: 'EMail' }) });
        groupEMail.appendTo(bodyCard);
        this._inputEMail = new Input2({});
        this._inputEMail.appendTo(groupEMail);
        this._inputEMail.setPlaceholder('e@mail.org');
        const groupMainGroup = new FormGroup2({ label: new LangTextV2({ text: 'Main group' }) });
        groupMainGroup.appendTo(bodyCard);
        this._selectMainGroup = new Select2({});
        this._selectMainGroup.appendTo(groupMainGroup);
        const rowOpt = new FormRow2({});
        rowOpt.appendTo(bodyCard);
        const groupIsAdmin = new FormGroup2({ label: new LangTextV2({ text: 'Is Admin' }) });
        groupIsAdmin.appendTo(rowOpt.createCol(4));
        this._switchIsAdmin = new Switch2({});
        this._switchIsAdmin.appendTo(groupIsAdmin);
        const groupIsDisabled = new FormGroup2({ label: new LangTextV2({ text: 'Is Disabled' }) });
        groupIsDisabled.appendTo(rowOpt.createCol(4));
        this._switchIsDisabled = new Switch2({});
        this._switchIsDisabled.appendTo(groupIsDisabled);
        // buttons -----------------------------------------------------------------------------------------------------
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * getUserId
     */
    getUserId() {
        return this._id;
    }
    /**
     * setUserId
     * @param id
     */
    setUserId(id) {
        this._id = id;
    }
    /**
     * getUsername
     */
    getUsername() {
        return this._inputUsername.getValue();
    }
    /**
     * setUsername
     * @param username
     */
    setUsername(username) {
        this._inputUsername.setValue(username);
    }
    /**
     * getFullname
     */
    getFullname() {
        return this._inputFullname.getValue();
    }
    /**
     * setFullname
     * @param fullname
     */
    setFullname(fullname) {
        this._inputFullname.setValue(fullname);
    }
    /**
     * getPassword
     */
    getPassword() {
        return this._inputPassword.getValue();
    }
    /**
     * setPassword
     * @param password
     */
    setPassword(password) {
        this._inputPassword.setValue(password);
    }
    /**
     * getPasswordRepeat
     */
    getPasswordRepeat() {
        return this._inputPasswordRepeat.getValue();
    }
    /**
     * setPasswordRepeat
     * @param password
     */
    setPasswordRepeat(password) {
        this._inputPasswordRepeat.setValue(password);
    }
    /**
     * getPin
     */
    getPin() {
        return this._inputPin.getValue();
    }
    setPin(pin) {
        this._inputPin.setValue(pin);
    }
    /**
     * getPinRepeat
     */
    getPinRepeat() {
        return this._inputPinRepeat.getValue();
    }
    /**
     * setPinRepeat
     * @param pin
     */
    setPinRepeat(pin) {
        this._inputPinRepeat.setValue(pin);
    }
    /**
     * getEMail
     */
    getEMail() {
        return this._inputEMail.getValue();
    }
    /**
     * setEMail
     * @param email
     */
    setEMail(email) {
        this._inputEMail.setValue(email);
    }
    /**
     * setMainGroupList
     * @param groups
     */
    setMainGroupList(groups) {
        this._selectMainGroup.clearValues();
        for (const group of groups) {
            this._selectMainGroup.addValue({
                key: `${group.id}`,
                value: group.description
            });
        }
    }
    /**
     * getMainGroup
     */
    getMainGroup() {
        return parseInt(this._selectMainGroup.getSelectedValue(), 10) || 0;
    }
    /**
     * setMainGroup
     * @param maingroup
     */
    setMainGroup(maingroup) {
        this._selectMainGroup.setSelectedValue(`${maingroup}`);
    }
    /**
     * setIsAdmin
     * @param isAdmin
     */
    setIsAdmin(isAdmin) {
        this._switchIsAdmin.setEnable(isAdmin);
    }
    /**
     * getIsAdmin
     */
    getIsAdmin() {
        return this._switchIsAdmin.isEnable();
    }
    /**
     * setIsDisabled
     * @param isDisabled
     */
    setIsDisabled(isDisabled) {
        this._switchIsDisabled.setEnable(isDisabled);
    }
    /**
     * getIsDisabled
     */
    getIsDisabled() {
        return this._switchIsDisabled.isEnable();
    }
    /**
     * resetValues
     */
    resetValues() {
        this.setUserId(null);
        this.setUsername('');
        this.setFullname('');
        this.setEMail('');
        this.setPassword('');
        this.setPasswordRepeat('');
        this.setPin('');
        this.setPinRepeat('');
        this.setMainGroup(0);
        this.setIsAdmin(false);
        this.setIsDisabled(false);
    }
}
